import { gql } from 'graphql-tag';
import { baseResponseGraphqlField } from '../../../base.graphql';

export const objectiveFields = `
  id
  uniqueId
  content
`;

export const CREATE_OBJECTIVE = gql`
  mutation CreateObjectiveMutation($input: ObjectiveInputObject!) {
    createObjectiveMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${objectiveFields}
      }
    }
  }
`;

export const UPDATE_OBJECTIVE = gql`
  mutation UpdateObjectiveMutation($input: ObjectiveInputObject!) {
    updateObjectiveMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${objectiveFields}
      }
    }
  }
`;

export const DELETE_OBJECTIVE = gql`
  mutation DeleteObjectiveMutation($uniqueId: String!) {
    deleteObjectiveMutation(uniqueId: $uniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`;

export const GET_OBJECTIVES = gql`
  query GetObjectives($filtering: ObjectiveFilteringInputObject) {
    getObjectives(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${objectiveFields}
      }
    }
  }
`;
